import React from 'react';
import { Form, Formik } from 'formik';
import { useIntl } from 'react-intl';
import * as Yup from 'yup';
import SuperLinkEditForm from './SuperLinkEditForm';
import { validationMessages } from '../../../utils/FormUtils';

const SuperLinkEditFormContainer = ({
  superLink,
  locale,
  updateSuperLink,
  listJobProfiles,
  reportForDropDown,
  searchJob,
  searching,
  handleCancel,
  accountCanSelectMatchPercentageForCareerCounselingReports,
}) => {
  const { formatMessage } = useIntl();

  const { activationOptions } = superLink;

  const initialValues = {
    superlinkName: superLink.name,
    reports: superLink.reports,
    description: superLink.description,
    notes: superLink.notes,
    notificationEmails: superLink.notificationEmails,
    sendRespondentReport: superLink.sendRespondentReport,
    sendRespondentCcInterestsReport: superLink.sendRespondentCcInterestsReport,
    sendRespondentCcPersonalityReport: superLink.sendRespondentCcPersonalityReport,
    printFriendlyReport: superLink.printFriendlyReport,
    locale: superLink.locale,
    enabled: activationOptions.enabled,
    activationType: activationOptions.activationType,
    numberOfAssessmentsToDisableAfter: activationOptions.numberOfAssessmentsToDisableAfter
      ? activationOptions.numberOfAssessmentsToDisableAfter
      : null,
    targetJobId: superLink.targetJob ? superLink.targetJob.id : null,
    ccInterestsMinimumMatchPercentage: superLink.ccInterestsMinimumMatchPercentage || 0,
    ccPersonalityMinimumMatchPercentage: superLink.ccPersonalityMinimumMatchPercentage || 0,
  };

  const validationSchema = Yup.object().shape({
    superlinkName: Yup.string().required(formatMessage(validationMessages.required)),
    targetJobId: Yup.string().required(formatMessage(validationMessages.required)),
    activationType: Yup.string().required(formatMessage(validationMessages.required)),
    numberOfAssessmentsToDisableAfter: Yup.number().when('activationType', {
      is: (activationType) => activationType === 'AUTOMATIC',
      then: Yup.number()
        .nullable()
        .required(formatMessage(validationMessages.required))
        .min(1, formatMessage(validationMessages.required)),
      otherwise: Yup.number().nullable(),
    }),
    ccInterestsMinimumMatchPercentage: Yup.number().when(['sendRespondentCcInterestsReport', 'reports'], {
      is: (sendRespondentCcInterestsReport, reports) => {
        return (
          accountCanSelectMatchPercentageForCareerCounselingReports &&
          (sendRespondentCcInterestsReport || (!!reports && reports.includes('CC_INTERESTS')))
        );
      },
      then: Yup.number()
        .required()
        .min(0)
        .max(100),
      otherwise: Yup.number().nullable(),
    }),
    ccPersonalityMinimumMatchPercentage: Yup.number().when(['sendRespondentCcPersonalityReport', 'reports'], {
      is: (sendRespondentCcPersonalityReport, reports) => {
        return (
          accountCanSelectMatchPercentageForCareerCounselingReports &&
          (sendRespondentCcPersonalityReport || (!!reports && reports.includes('CC_PERSONALITY')))
        );
      },
      then: Yup.number()
        .required()
        .min(0)
        .max(100),
      otherwise: Yup.number().nullable(),
    }),
  });

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={(values, formikBag) => {
        const { resetForm } = formikBag;
        updateSuperLink(values);
        resetForm();
      }}
    >
      <Form>
        <SuperLinkEditForm
          handleCancel={handleCancel}
          listJobProfiles={listJobProfiles}
          superLink={superLink}
          locale={locale}
          searching={searching}
          searchJob={searchJob}
          reportForDropDown={reportForDropDown}
          accountCanSelectMatchPercentageForCareerCounselingReports={
            accountCanSelectMatchPercentageForCareerCounselingReports
          }
        />
      </Form>
    </Formik>
  );
};

export default SuperLinkEditFormContainer;
